import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Show member")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Delete")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, {
    columns: _ctx.memberColumns,
    rows: _ctx.members,
    "row-key": "id",
    filter: _ctx.filter,
    pagination: _ctx.pagination,
    "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
    onRequest: _ctx.onRequest,
    loading: _ctx.loading,
    flat: "",
    class: "sticky-actions-column"
  }, {
    "body-cell-actions": _withCtx((props) => [
      _createVNode(_component_q_td, { props: props }, {
        default: _withCtx(() => [
          _createVNode(_component_q_btn, {
            dense: "",
            round: "",
            flat: "",
            color: "grey",
            onClick: _withModifiers(($event: any) => (_ctx.onShowMemberRow(null, props.row)), ["stop"]),
            icon: "pageview"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_q_btn, {
            dense: "",
            round: "",
            flat: "",
            color: "grey",
            onClick: _withModifiers(($event: any) => (_ctx.onDeleteMemberRow(props.row)), ["stop"]),
            icon: "delete"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 2
      }, 1032, ["props"])
    ]),
    _: 1
  }, 8, ["columns", "rows", "filter", "pagination", "onRequest", "loading"]))
}